export default __webpack_public_path__ + "static/media/chevron-down-1.e5842cd1.svg";